import { render, staticRenderFns } from "./Communications.vue?vue&type=template&id=7897bd94&scoped=true&"
import script from "./Communications.vue?vue&type=script&lang=js&"
export * from "./Communications.vue?vue&type=script&lang=js&"
import style0 from "./Communications.vue?vue&type=style&index=0&id=7897bd94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7897bd94",
  null
  
)

export default component.exports